// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2lRI6","actions":"GroupTable_actions__14_-o","deleteModalFooter":"GroupTable_deleteModalFooter__RQx6j"};